import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';

import type {ButtonProps, AriaMenuItem} from '@pexip/components';
import {AriaMenu, Button, Icon, IconTypes} from '@pexip/components';

import {TestId} from '../../../test/testIds';

export const JoinMeetingButtonWithOptions: React.FC<
    ButtonProps & {
        isDisabled?: boolean;
        onWithVideoClick: () => void;
        onWithAudioOnlyClick: () => void;
    }
> = ({isDisabled, className, onWithVideoClick, onWithAudioOnlyClick}) => {
    const {t} = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const menuItems: AriaMenuItem[] = [
        {
            key: 'join-with-video',
            label: t('common.join-with-video', 'Join with video'),
            testId: TestId.ButtonJoinWithVideo,
            onItemClick: onWithVideoClick,
            closeMenuOnItemClick: true,
        },
        {
            key: 'join-audio-only',
            label: t('common.join-audio-only', 'Join audio only'),
            testId: TestId.ButtonJoinAudioOnly,
            onItemClick: onWithAudioOnlyClick,
            closeMenuOnItemClick: true,
        },
    ];

    return (
        <AriaMenu
            onOpenChange={setIsOpen}
            items={menuItems}
            button={
                <Button
                    className={className}
                    isActive={isOpen}
                    enhancerStart={<Icon source={IconTypes.IconVideoOn} />}
                    enhancerEnd={
                        <Icon
                            source={
                                isOpen
                                    ? IconTypes.IconChevronUp
                                    : IconTypes.IconChevronDown
                            }
                        />
                    }
                    isDisabled={isDisabled}
                    size="medium"
                    variant="success"
                    data-testid={TestId.ButtonJoinMeetingWithOptions}
                >
                    {t('common.join', 'Join')}
                </Button>
            }
            popoverPlacement="bottom right"
        />
    );
};
